import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_download.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-11536f7f")

_pushScopeId("data-v-11536f7f")
const _hoisted_1 = { class: "scan-failed-card" }
const _hoisted_2 = { class: "flex flex-row items-center justify-between" }
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "download-icon"
}, null, -1)
const _hoisted_5 = { class: "body-scroll" }
const _hoisted_6 = { class: "text-red-lp-100 font-bold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('stiSc.scanFailed.title')), 1),
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadExcel && _ctx.downloadExcel(...args))),
        onEnter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadExcel && _ctx.downloadExcel(...args)))
      }, [
        _hoisted_4
      ], 32)
    ]),
    _createVNode("div", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "item"
        }, [
          _createVNode("div", _hoisted_6, _toDisplayString(item.sttNo), 1),
          _createVNode("div", {
            class: "text-gray-lp-300 text-xs whitespace-nowrap overflow-ellipsis overflow-hidden",
            title: item?.errorMessage?.[_ctx.languageKey] ? item.errorMessage[_ctx.languageKey] : item.errorMessage
          }, _toDisplayString(item?.errorMessage?.[_ctx.languageKey] ? item.errorMessage[_ctx.languageKey] : item.errorMessage), 9, ["title"])
        ]))
      }), 128))
    ])
  ]))
})